'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$29() {
  this.aZe = null;
  this.aZf = false;
}
export { $c_Lpresto_GroupsView$$anon$29 as $c_Lpresto_GroupsView$$anon$29 };
$p = $c_Lpresto_GroupsView$$anon$29.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$29;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$29() {
}
export { $h_Lpresto_GroupsView$$anon$29 as $h_Lpresto_GroupsView$$anon$29 };
$h_Lpresto_GroupsView$$anon$29.prototype = $p;
$p.P = (function() {
  if ((!this.aZf)) {
    this.aZe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T5($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aZf = true;
  }
  return this.aZe;
});
var $d_Lpresto_GroupsView$$anon$29 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$29, "presto.GroupsView$$anon$29", ({
  Kg: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_GroupsView$$anon$29 as $d_Lpresto_GroupsView$$anon$29 };
//# sourceMappingURL=presto.-Groups-View$$anon$29.js.map
